/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Updated_ToastInputs */

const en_profile_updated_toast = /** @type {(inputs: Profile_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile updated.`)
};

const pt_br2_profile_updated_toast = /** @type {(inputs: Profile_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil atualizado.`)
};

/**
* | output |
* | --- |
* | "Profile updated." |
*
* @param {Profile_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_updated_toast = /** @type {((inputs?: Profile_Updated_ToastInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Updated_ToastInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_updated_toast(inputs)
	return pt_br2_profile_updated_toast(inputs)
});